import React, { useEffect, useState } from 'react';
import Catalog from './Catalog';
import delete_icon from "../../../assets/images/delete.svg";
import delete_green from "../../../assets/images/delete-green.svg";
import basket_icon from '../../../assets/images/basket.svg'

const Product_filters = (props) => {

    const [producers, setProducers] = useState(props.producers);
    const [categories, setCategories] = useState(props.categories);
    const [internationalization, setInternationalization] = useState(props.internationalization);

    const [checkboxesValues, setCheckboxesValues] = useState([]);

    const [optionsArr, setOptionsArr] = useState([]);

    const [priceFromVal, setPriceFromVal] = useState('');
    const [priceTillVal, setPriceTillVal] = useState('');

    const [activeFilter, SetActiveFilter] = useState('category');
    const [activeTab, setActiveTab] = useState("filters");


    const updateOptions = (value, category, text) => {

        let option = {
            "value": value,
            "category": category,
            "text": text
        }

        let newArr = optionsArr;

        let filtredArr = newArr.filter((item,index) => {
            return item["value"] !== value
        })

        if(newArr.length === filtredArr.length) {
            newArr.push(option);
            setOptionsArr(newArr);
        } else {
            setOptionsArr(filtredArr);
        }

        if(checkboxesValues.includes(value)) {
            let checkboxArr = checkboxesValues;
            checkboxArr.splice(checkboxArr.indexOf(value), 1);
            setCheckboxesValues(checkboxArr);
        } else {
            setCheckboxesValues([...checkboxesValues, value]);
        }
    }

    const updatePriceOptions = (value, category, subcategory) => {

        let option = {
            "value": value,
            "category": category,
            "text": value,
            "subcategory": subcategory
        }
        let filtredArr;

        let newArr = optionsArr;

        if (subcategory) {

            filtredArr = newArr.filter((item,index) => {
                return item.subcategory !== subcategory
            })

        } else {

            filtredArr = newArr.filter((item,index) => {
                return item["value"] !== value && item.subcategory !== subcategory
            })
        }

        if(value.length) {
            filtredArr.push(option);
        }

        setOptionsArr(filtredArr);

        switch(subcategory) {
            case("from"):
                setPriceFromVal(value)
                break
            case("till"):
                setPriceTillVal(value);
                break
        }

    }

    const clearOption = (optionToDelete) => {

        let arr = optionsArr;

        let newArr = arr.filter((option, index) => {
            return optionToDelete.value !== option.value
        })
        if(!optionToDelete.hasOwnProperty("subcategory")) {
            let checkboxesArr = checkboxesValues;

            checkboxesArr.splice(checkboxesArr.indexOf(optionToDelete.value), 1)

            setCheckboxesValues(checkboxesArr);
        }

        if(optionToDelete.subcategory === "from") {
            setPriceFromVal("");
        } else if (optionToDelete.subcategory === "till") {
            setPriceTillVal("");
        }

        setOptionsArr(newArr)

        props.clearSingleOption(optionToDelete);
    }

    const clearAllOptions = () => {
        setCheckboxesValues([]);
        setOptionsArr([]);
        setPriceFromVal("");
        setPriceTillVal("");

        props.clearAllData();
    }


    return (
        <div className="catalog-sidebar-wrapper">
            <div className="catalog-sidebar">
                <span className="close-sidebar"><img src={delete_icon} alt="delete icon"></img></span>
                <div className="catalog-sidebar-top">
                    <h6 className={activeTab === "filters" ? "title-active" : ""} onClick={() => setActiveTab('filters')}>{internationalization.catalog_filters}</h6>
                    <h6 className={activeTab === "catalog" ? "title-active" : ""}  onClick={() => setActiveTab('catalog')}>Каталог</h6>
                    <span className={`filter-clear filter-clear-top ${optionsArr.length ? "filter-clear-top-show" : ""}`} onClick={() => {clearAllOptions()}}> <img src={delete_green} alt="delete icon"></img> {internationalization.filter_decline}</span>
                </div>

                {activeTab === "filters" ?

                    <form className="filter">
                        <div className="filter-categories">

                            <div className={`catalog-sub-dropdown ${activeFilter === "producers" ? "catalog-sub-dropdown-open" : ""}`}>
                                <div className="catalog-sub-dropdown-row" onClick={() => SetActiveFilter("producers")}>
                                    <span className="catalog-sub-dropdown-row-text">{internationalization.producer_title}</span>
                                    <span className="catalog-sub-dropdown-row-icon"></span>
                                </div>
                                <ul className={`catalog-sub-dropdown-list ${activeFilter === "producers" ? "catalog-sub-dropdown-list-open" : ""}`}>

                                    {producers.map((producer, index) => {
                                        return  <li className="catalog-sub-dropdown-list-item" key={index}>
                                                    <input className="filter-checkbox"
                                                        data-category="producers"
                                                        data-text={producer.localazed_name}
                                                        id={`producer${producer.id}`}
                                                        type="checkbox"
                                                        onChange={(e) => {props.addCheckboxField(e); updateOptions(`producer${producer.id}`, "producers", producer.localazed_name)}}
                                                        checked={checkboxesValues.includes(`producer${producer.id}`)}
                                                    >

                                                    </input>
                                                    <label className="filter-label" htmlFor={`producer${producer.id}`}> {producer.localazed_name} <span className="filter-label__count">({producer.products_count})</span> </label>
                                                </li>
                                    })}

                                </ul>
                            </div>

                            <div className={`catalog-sub-dropdown ${activeFilter === "category" ? "catalog-sub-dropdown-open" : ""}`}>
                                <div className="catalog-sub-dropdown-row" onClick={() => SetActiveFilter("category")}>
                                    <span className="catalog-sub-dropdown-row-text">{internationalization.catalog_subtitle}</span>
                                    <span className="catalog-sub-dropdown-row-icon"></span>
                                </div>
                                <ul className={`catalog-sub-dropdown-list ${activeFilter === "category" ? "catalog-sub-dropdown-list-open" : ""}`}>

                                    {categories.map((category, index) => {
                                        return  <li key={index} className="catalog-sub-dropdown-list-item">
                                                    <input className="filter-checkbox"
                                                    id={`category${category.id}`}
                                                    data-category="categories"
                                                    data-text={category.localazed_name}
                                                    type="checkbox"
                                                    onChange={(e) => {props.addCheckboxField(e); updateOptions(`category${category.id}`, "categories", category.localazed_name)}}
                                                    checked={checkboxesValues.includes(`category${category.id}`)}
                                                    >
                                                </input>
                                                    <label className="filter-label" htmlFor={`category${category.id}`}>{category.localazed_name} <span className="filter-label__count">({category.products_count_for_main})</span> </label>
                                                </li>
                                    })}

                                </ul>
                            </div>

                        </div>

                        <div className="filter-price">
                            <span className="filter-price-row">{internationalization.product_price}</span>
                            <div className="filter-price-fields">
                                <span className="filter-price-fields-point">{internationalization.price_from}</span>
                                <input type="number" id="from" value={priceFromVal} className="filter-price-fields-input" onChange={(e) => {props.addPriceValue(e); updatePriceOptions(e.target.value, "price", "from")}} placeholder="20"></input>
                                <span className="filter-price-fields-point">{internationalization.price_till}</span>
                                <input type="number" id="till" value={priceTillVal} className="filter-price-fields-input" onChange={(e) => {props.addPriceValue(e); updatePriceOptions(e.target.value, "price", "till")}} placeholder="50000" ></input>
                                <span className="filter-price-fields-point">грн</span>
                            </div>
                        </div>

                        <div className={`selections ${optionsArr.length ? "selections-open" : ""}`}>
                            <h6 className="selections-title">{internationalization.filter_selections}</h6>
                            <ul className="selections-options">
                                {optionsArr.map((option, index) => {
                                    return  <li key={index} className="options-item" data-value={option.value} data-category={option.category} data-subcategory={option.subcategory}>
                                                <span className="options-item-text">
                                                    {option.subcategory ? option.subcategory === "from" ? `${internationalization.price_from} ${option.text} грн` : `${internationalization.price_till} ${option.text} грн` : `${option.text}`}</span>
                                                <span className="options-item-clear" onClick={() => {clearOption(option)}}></span>
                                            </li>
                                })}
                            </ul>
                            <input type="button" className="green-link catalog-request" onClick={() => {props.submitFilter()}} value={internationalization.filter_apply}></input>
                            <span className="filter-clear" onClick={() => {clearAllOptions()}}><img src={delete_green} alt="delete icon"></img> {internationalization.filter_decline}</span>
                        </div>

                    </form>
                 :

                    <Catalog categories={props.categories}/>

                 }
            </div>
        </div>

    );
};

export default Product_filters;
